import React, { forwardRef, useEffect, useState } from "react";
// Mui
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    FormGroup,
    Checkbox,
    Typography,
    TextField,
    Button,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
    Slide,
} from "@mui/material";
import dayjs from "dayjs";

// Components
import { getWeekOfYear } from "../../../function/WOY";

// Redux
import { getProfile } from "../../../reducer/profileSlice";
import { useSelector } from "react-redux";
import { getEOCActive } from "../../../reducer/eocActiveSlice";
import { getEOCConfig } from "../../../reducer/eocConfigSlice";
import ResponseDialog from "../ComponentReuse/ResponseDialog";
import CustomDatePicker from "../ComponentReuse/CustomDatePicker";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function EOCEdit(props) {
    const { open, onClose, dataTitle, onSuccess } = props;
    const eocActive = useSelector(getEOCActive);
    const eocConfig = useSelector(getEOCConfig);
    const profile = useSelector(getProfile);
    const [incidentCommander, setIncidentCommander] = useState();
    const [participatingOrg, setParticipatingOrg] = useState([]);
    const [startEOCDate, setStartEOCDate] = useState(null);
    const [isRadioButtonSelected, setIsRadioButtonSelected] = useState(true);
    const [status, setStatus] = useState("");
    const [modalResponse, setModalResponse] = useState(false);

    useEffect(() => {
        if (open && eocActive) {
            setIncidentCommander(eocActive?.incident_commander);
            setParticipatingOrg(eocActive?.participating_org);
            setStartEOCDate(dayjs(eocActive?.create_timestamp).valueOf());
        }
    }, [open, eocActive])

    useEffect(() => {
        if (incidentCommander?.ic_id === '0106') {
            setIsRadioButtonSelected(false);
        }
    }, [incidentCommander])

    const handleDate = (value) => {
        setStartEOCDate(value.valueOf());
    };

    const handleRadioChange = (event) => {
        const { name, value } = event.target;
        if (value === "อื่นๆ ระบุ") {
            setIsRadioButtonSelected(false);
        } else {
            setIsRadioButtonSelected(true);
        }
        setIncidentCommander({
            ic_id: name,
            ic_name: value,
        });
    };

    const handleTextValue = (e) => {
        const { name, value } = e.target;
        if (value !== incidentCommander?.ic_name) {
            setIncidentCommander({
                ic_id: name,
                ic_name: value,
            });
        }
    };

    const handleCheckboxChange = (e) => {
        const checkboxId = e.target.value;
        const checkboxName = e.target.name;

        if (eocActive?.participating_org) {
            setParticipatingOrg((prevFormData) => {
                if (e.target.checked) {
                    return [
                        ...prevFormData,
                        { po_type_id: checkboxId, po_type_name: checkboxName },
                    ];
                } else if (!e.target.checked) {
                    return prevFormData.filter((org) => org.po_type_id !== checkboxId);
                }
                return prevFormData;
            });
        }
    };

    const getWOY = () => {
        let woy = { week: "", year: "" };
        let getWOY = getWeekOfYear(dayjs(startEOCDate).toDate());
        woy.week = getWOY.week;
        woy.year = getWOY.year;
        return woy;
    };

    const handleSubmit = async () => {
        try {
            if (
                Object.keys(incidentCommander).length !== 0 &&
                Object.keys(participatingOrg).length !== 0 &&
                startEOCDate !== undefined
            ) {
                const sortedParticipatingOrg = participatingOrg
                    ?.slice()
                    .sort((a, b) => {
                        return a.po_type_id.localeCompare(b.po_type_id);
                    });

                let dataSend = {
                    incident_commander: incidentCommander,
                    start_eoc_timestamp: startEOCDate.toString(),
                    start_eoc_week: getWOY().week,
                    start_eoc_year: getWOY().year,
                    participating_org: sortedParticipatingOrg,
                    eoc_id: eocActive?.eoc_id,
                    creator_id: profile?.inum,
                    creator_name: profile?.displayName,
                    remark: "",
                    org_id: profile?.org_id,
                    org_name: profile?.org_name,
                    phone: profile?.telephone,
                    email: profile?.mail,
                };
                const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/update_eoc`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataSend),
                });

                if (response.ok) {
                    setStatus("ทำการแก้ไข EOC เสร็จสิ้น");
                    setModalResponse(true);
                } else {
                    setStatus("ไม่สามารถแก้ไข EOC ได้");
                    setModalResponse(true);
                }
            } else {
                console.log("incidentCommander", incidentCommander);
                setStatus("ไม่ได้ใส่ข้อมูลประเภทหน่วยงานที่มีส่วนร่วม");
                setModalResponse(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleCloseResponse = () => {
        setModalResponse(false);
        if (
            Object.keys(incidentCommander).length !== 0 &&
            Object.keys(participatingOrg).length !== 0 &&
            startEOCDate !== undefined
        ) {
            onSuccess();
            onClose();
        }
    };

    const defaultDate = () => {
        const timeStamp = dayjs(parseInt(eocActive?.start_eoc_timestamp));
        return timeStamp;
    };

    const ckeckParticipatingOrg = (po_type_id) => {
        const result = participatingOrg.some(
            (org) => org.po_type_id === po_type_id
        )
        return result;
    }

    const handleClose = () => {
        setIncidentCommander();
        setParticipatingOrg([]);
        setStartEOCDate(null);
        setIsRadioButtonSelected(true);
        setStatus("");
        setModalResponse(false);
        onClose();
    };

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <DialogTitle className='py-3'>
                    <Typography variant="body1" className="text-black">แก้ไข {dataTitle?.org_level}</Typography>
                </DialogTitle>
                <DialogContent className='p-4 md:p-8 max-w-7xl w-full overflow-auto' dividers>
                    <div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-y-8'>
                        <div>
                            <Typography variant="subtitle2" className='text-[#D48061]'>
                                {dataTitle?.org_name_title}
                            </Typography>
                            <Typography variant="body1">{dataTitle?.org_name}</Typography>
                            <div className='mt-8'>
                                <Typography
                                    variant="subtitle2" className='text-[#D48061]'
                                >
                                    วันที่เปิด EOC
                                </Typography>
                                <CustomDatePicker
                                    className='max-w-[300px]'
                                    slotProps={{ textField: { size: "small", required: true } }}
                                    // defaultValue={defaultDate()}
                                    value={defaultDate()}
                                    minDate={dayjs()}
                                    onChange={handleDate}
                                />
                            </div>
                            <div className='mt-8'>
                                <Typography
                                    variant="subtitle2"
                                    className='text-[#D48061]'
                                >
                                    ผู้บัญชาการเหตุการณ์
                                </Typography>
                                <FormControl>
                                    <FormLabel id="demo-radio-buttons-group-label"></FormLabel>
                                    <RadioGroup
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 19,
                                            },
                                        }}
                                        onChange={handleRadioChange}
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group"
                                    >
                                        {eocConfig?.config?.incident_commander[
                                            profile?.org_level
                                        ]?.ic.map((data, index) => {
                                            return (
                                                <div key={index}>
                                                    <FormControlLabel
                                                        value={data.ic_name}
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    "&.Mui-checked": {
                                                                        color: "#D48061",
                                                                    },
                                                                }} />}
                                                        name={data.ic_id}
                                                        label={data.ic_name}
                                                        checked={data.ic_id === incidentCommander?.ic_id}
                                                        sx={{
                                                            "&$checked": {
                                                                color: "#D48061",
                                                            },
                                                        }}
                                                    />
                                                    {data.ic_name ===
                                                        eocConfig?.config?.incident_commander[
                                                            profile?.org_level
                                                        ]?.ic[
                                                            eocConfig?.config?.incident_commander[
                                                                profile?.org_level
                                                            ]?.ic.length - 1
                                                        ].ic_name && (
                                                            <TextField
                                                                size="small"
                                                                name={data.ic_id}
                                                                onChange={handleTextValue}
                                                                disabled={isRadioButtonSelected}
                                                                placeholder="ระบุ"
                                                                value={(incidentCommander?.ic_id === "0106" && incidentCommander?.ic_name !== "อื่นๆ ระบุ") ? incidentCommander?.ic_name : ""}
                                                            // defaultValue={
                                                            //     incidentCommander?.ic_id === "0106" ? eocActive?.incident_commander?.ic_name : ""
                                                            //     // data.ic_id === incidentCommander?.ic_id ? eocActive?.incident_commander?.ic_name : ""
                                                            // }
                                                            />
                                                        )}
                                                </div>
                                            );
                                        })}
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </div>

                        <div>
                            <Typography
                                variant="subtitle2"
                                className='text-[#D48061] mb-1'
                            >
                                ประเภทหน่วยงานที่มีส่วนร่วม
                            </Typography>
                            <div className="w-full grid gap-3 grid-cols-1">
                                {eocConfig?.config?.participating_org_type.map((data, index) => {
                                    return (
                                        <Stack
                                            key={index}
                                            direction='row'
                                            sx={{
                                                backgroundColor: ckeckParticipatingOrg(data?.po_type_id) ? "rgb(253, 248, 246)" : "white",
                                                minWidth: '260px',
                                                border: ckeckParticipatingOrg(data?.po_type_id) ? '1px solid #cd6c4a' : '1px solid #ccc',
                                            }}
                                            className='rounded p-3'
                                        >
                                            <Checkbox
                                                value={data?.po_type_id}
                                                name={data?.po_type_name}
                                                onChange={handleCheckboxChange}
                                                checked={ckeckParticipatingOrg(data?.po_type_id)}
                                            />
                                            <Typography variant="body1">
                                                {data?.po_type_name}
                                                <br />
                                                <Typography variant="body2" component="span" sx={{ color: '#757575' }}>
                                                    เช่น {data?.example.toString().replaceAll(",", " ")}
                                                </Typography>
                                            </Typography>
                                        </Stack>
                                    );
                                })}
                            </div>
                        </div>

                    </div>
                </DialogContent>
                <DialogActions className='mx-2 md:mx-6 gap-2 my-1'>
                    <Button
                        variant="contained"
                        className='bg-[#cd6c4a] hover:bg-[#cd6c4a] w-28'
                        onClick={handleSubmit}
                    >
                        แก้ไข EOC
                    </Button>
                    <Button
                        variant="outlined"
                        className='w-28'
                        color='inherit'
                        onClick={handleClose}
                    >
                        ยกเลิก
                    </Button>
                </DialogActions>
            </Dialog>
            <ResponseDialog
                open={modalResponse}
                onClose={handleCloseResponse}
                dataResponse={status}
            />
        </>
    );

}
